import React, { Component } from "react";
import "../../styles/Contact.css";

//import Logo from './logo.svg';
import Logo from '../../img/img-logo.svg';
import Announcement from 'react-announcement'

// Components
import Header from "./Header.js";
//import Consumer from "./Consumer.js";
//import Business from "./Business.js";
//import Community from "./Community.js";
import Chat from "./Chat.js";
import WhatsApp from "./WhatsApp.js";
import Telegram from "./Telegram.js";
import Help from "./Help.js";
import ConsumerButton from "./ConsumerButton.js";
import BusinessButton from "./BusinessButton.js"
import CommunityButton from "./CommunityButton.js";
import SocialMediaIcons from "./SocialMediaIcons.js";
import Follow from "./Follow.js";
import Copyright from "./Copyright.js";
import Legal from "./Legal.js";
///import Privacy from "./Privacy.js";
//import Terms from "./Terms.js";

//

//<Consumer />
//<Business />
//<Community />

//<Privacy />
//<Terms />

class Contact extends Component {
  render() {
    return (
      <div className="Contact" id="Contact">
        <Header />
        <Chat />
        <WhatsApp />
        <Telegram />
        <Help />
        <ConsumerButton />
        <BusinessButton />
        <CommunityButton />
        <SocialMediaIcons />
        <Follow />
        <Copyright />
        <Legal />
        <Announcement
          title="In response to the COVID-19 pandemic, fortissimo is helping people in the local food and beverage industry get back on their feet first"
          subtitle="To Join As Delivery Genies, click here"
          link="https://t.me/joinchat/eHf7fLKS4X81NTM9"
          imageSource={Logo}
          daysToLive={0}
          secondsBeforeBannerShows={5}
          closeIconSize={30}    
        />
      </div>
    );
  }
}

export default Contact;

//<Announcement
  //title="In response to the COVID-19 pandemic, fortissimo is creating an online experience for you"
  //subtitle="Get an e-voucher from your local food and beverage business when you join our consumer wish list"
  //link="https://goo.gl/forms/68rt37pElAEhk3M82"
  //imageSource={Logo}
  //daysToLive={0}
  //secondsBeforeBannerShows={5}
  //closeIconSize={30}    
///>
//<Announcement
  //title="In response to the COVID-19 pandemic, fortissimo is creating an online experience for you"
  //subtitle="Get an e-voucher from your local food and beverage business when you join our consumer wish list"
  //link="https://t.me/joinchat/UftQDdJtd4e-_uZg"
  //imageSource={Logo}
  //daysToLive={0}
  //secondsBeforeBannerShows={5}
  //closeIconSize={30}    
///>